import ChapterSubjectIndex from '@/views/chapter-subject/ChapterSubjectIndex.vue';
import AddChapterSubject from '@/views/chapter-subject/AddChapterSubject.vue';
import EditChapterSubject from '@/views/chapter-subject/EditChapterSubject.vue';

export default [
  {
    path: '/chapter-subjects',
    name: 'chapter-subjects.index',
    component: ChapterSubjectIndex,
    meta: { 
      title: 'إدارة روابط الفصول والمواد',
      requiresAuth: true
    },
    children: [
      {
        path: 'create',
        name: 'chapter-subjects.create',
        component: AddChapterSubject,
        meta: { 
          title: 'إضافة رابط جديد',
          requiresAuth: true
        }
      },
      {
        path: ':id/edit',
        name: 'chapter-subjects.edit',
        component: EditChapterSubject,
        meta: { 
          title: 'تعديل الرابط',
          requiresAuth: true 
        },
        props: true
      }
    ]
  }
];